export let FirstMenuLayout = {
  name: 'layout',
  title: 'Edit layout',
  shortcut: 'l'
}
